export const createSwiper = (selector, options) => {
    const elements = document.querySelectorAll(selector);
    if (elements.length < 1) {
        return;
    }
    return new Swiper(selector, options);
};